export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9068.9d4af903.jpg";